import React from 'react';
import { APP_STORE_URL } from './assetPaths';
import './AppStoreButton.css';

function AppStoreButton({ appleLogo = false, text = 'Download' }) {
  return (
    <a className="app-store-button" href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
      {appleLogo && (
        <span className="app-store-button__apple" aria-hidden="true"></span>
      )}
      <span>{text}</span>
    </a>
  );
}

export default AppStoreButton;
